<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		tag = 'div',
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
		tag?: 'div' | 'h2'
	} = $props()
</script>

<svelte:element
	this={tag}
	bind:this={ref}
	class={cn(
		'[&_a]:hover:text-foreground font-medium group-has-[>svg]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3',
		className
	)}
	data-slot="alert-title"
	{...restProps}
>
	{@render children?.()}
</svelte:element>
